// Resize the thumbnails
// 288 pt @ 3x = 864
export const MINIMUM_THUMBNAIL_WIDTH = 864

export const MINIMUM_THUMBNAIL_HEIGHT = 864

export const THUMBNAIL_LOGICAL_TIME_HEADER = 'LogicalTime'

export const THUMBNAIL_SITE_ID_HEADER = 'SiteId'
